import React from 'react';

import { Checkbox } from '@pkg/components';
import { type Collectible } from '@pkg/graphql/codegen/graphql';
import { useBreakpoints } from '@pkg/hooks';

import { useNFTsPageStore } from '@app/store/zustand';

import { SortToggle } from '../../../../../components/ListView/SortToggle';
import { Cell } from '../ListEntry/styles';

import { InfoCell, Row } from './styles';

interface Props {
    nftEntries?: Collectible[];
}

export const ListHeader = ({ nftEntries }: Props) => {
    const { isMobile } = useBreakpoints();

    const { isSelectAll, handleSelectAll } = useNFTsPageStore();

    if (isMobile) return null;

    return (
        <Row>
            <InfoCell>
                <SortToggle onClick={() => handleSelectAll(nftEntries || [])}>
                    <Checkbox checked={isSelectAll} readOnly />
                    Select All
                </SortToggle>
            </InfoCell>
            <Cell>
                <SortToggle>Floor</SortToggle>
            </Cell>
            <Cell>
                <SortToggle>Last Sale</SortToggle>
            </Cell>
            <Cell>
                <SortToggle>List Price</SortToggle>
            </Cell>
            <Cell>
                <SortToggle>Top Offer</SortToggle>
            </Cell>
            <Cell />
        </Row>
    );
};
